<script>
 import ConfirmCancelInvoice from "../modals/ConfirmCancelInvoice";
  
export default {
     name: "UnpostedList",
    data() {
        return {
            invoices: [],
            suppliers: [],
             confirmcancel:false,
            filter:{
             search:"",
             supplierId:0,
             SearchOnly:false,
             dateFrom: window.moment().format(`YYYY-MM-DD`),
             dateTo: window.moment().format(`YYYY-MM-DD`),
                },
                currentinvoiceNo:""
                
        };
    },
    mounted() {

        this.fetchUnpostedInvoices();
         this.fetchSuppliers();
    },
    components: {
       ConfirmCancelInvoice 
    },
    computed:{
 // "items-details-form": () => import('./wizard/ItemDetails.vue'),
   
    },
    methods: {

        fetchUnpostedInvoices() {
          this.$root.loading = true;
          this.$accountsHttp.get('SupplierInvoice/UnPostedInvoices').then(response => {
            this.invoices = response.data;
            this.$root.loading = false;
            this.confirmcancel=false;
          }).catch(() => this.$root.loading = false);
        },
        fetchSupplierInvoices() {
            this.filter.SearchOnly=false;
           
            let url = `SupplierInvoice/GetUnPostedSupplierInvoice`;
                url +=`?SupplierId=${this.filter.supplierId}`;
                url +=`&DateFrom=${this.filter.dateFrom}&DateTo=${this.filter.dateTo}`;
                url +=this.filter.search ? `&SearchField=${this.filter.search}` : ``;
                url +=`&SearchOnly=${this.filter.SearchOnly}`;
               return this.$http.get(url).then(({ data }) => {
                this.invoices = data;
            }).catch(() => {});
        },
          fetchSupplierInvoicesSearchOnly() {
            this.filter.SearchOnly=true;
            let url = `SupplierInvoice/GetUnPostedSupplierInvoice`;
                url +=`?SupplierId=${this.filter.supplierId}`;
                url +=`&DateFrom=${this.filter.dateFrom}&DateTo=${this.filter.dateTo}`;
                url +=this.filter.search ?`&SearchField=${this.filter.search}` : ``;
                url +=`&SearchOnly=${this.filter.SearchOnly}`;
                 return this.$http.get(url).then(({ data }) => {
                this.invoices = data;
            }).catch(() => {});
        },
          fetchSuppliers() {
            let url = `Shared/GetSuppliers`;

            return this.$http.get(url).then(({ data }) => {
                this.suppliers = data;
            }).catch(() => {});
        },
        CancelLPO(InvoiceNo){
this.currentinvoiceNo=InvoiceNo;
this.confirmcancel=true;
        }
    }
}
</script>
<template>
 <div class="flex flex-wrap content-start overflow-auto" style="height:78vh;">
        <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" v-model.trim="filter.search" 
                    @keydown.enter="fetchSupplierInvoicesSearchOnly" 
                    placeholder="press enter to search only"
                    id="grid-search" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom" 
                    id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input type="date" v-model.trim="filter.dateTo" 
                    id="grid-date-to" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-cashier" class="label-control">Supplier:</label>
                  <v-select
                v-model="filter.supplierId" 
                :options="suppliers" 
                :reduce="supplier => supplier.id"
                label="name"
                class="bg-white text-sm" 
            />
              </div>
              
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-info text-xs rounded" 
                    @click.prevent="() => {
                        $root.loading=true;
                        fetchSupplierInvoices().then(() => {
                            $root.loading=false;
                        }).catch(() => { $root.loading=false; });
                    }">
                        <i class="fa fa-filter"></i> Filter</button>
              </div>  <table class="table table-hover">
            <thead class="bg-blue-500 text-xs text-white">
                <tr class="w-full flex">
                    <th class="p-tiny w-1/6">Supplier</th>
                    <th class="p-tiny w-1/6">Invoice No</th>
                    <th class="p-tiny w-1/6">Ext Ref</th>
                    <th class="p-tiny w-1/6">Txn Date</th>
                    <th class="p-tiny w-1/6">Due Date</th>
                    <th class="p-tiny w-1/6">KRA Pin</th>
                    <th class="p-tiny w-1/6">KRA CU No</th>
                    <th class="p-tiny w-1/6">KRA Invoice No</th>
                     <th class="p-tiny w-1/6">User</th>
                    <th class="p-tiny w-1/6">Action</th>
                </tr>
            </thead>
            <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:70vh;">
                <tr class="w-full flex" v-for="(invoice,idx) in invoices" :key="idx">
                    <td class="p-tiny w-1/6">{{ invoice.supplier }}</td>
                    <td class="p-tiny w-1/6">{{ invoice.invoiceNo }}</td>
                    <td class="p-tiny w-1/6">{{ invoice.extRef }}</td>
                    <td class="p-tiny w-1/6">{{ invoice.txnDate | dateFormat }}</td>
                    <td class="p-tiny w-1/6">{{ invoice.dueDate | dateFormat }}</td>
                    <td class="p-tiny w-1/6">{{ invoice.piN_No}}</td>
                    <td class="p-tiny w-1/6">{{ invoice.kracuno}}</td>
                    <td class="p-tiny w-1/6">{{ invoice.krainvoiceno}}</td>
                    <td class="p-tiny w-1/6">{{ invoice.userName || `-` }}</td>
                    <td class="p-tiny w-1/6 m-1">
                        <!-- <router-link class="btn-sm btn-info text-xs rounded m-1" 
                            :to="{ name: 'suppliers-dashboard.invoice-list.view', params: { invoiceNo: invoice.invoiceNo } }" title="View">
                                <i class="fa fa-eye"></i></router-link> -->
                                <router-link class="btn-sm btn-info text-xs rounded m-1"  :to="{ name: `suppliers-dashboard.invoice-list.create`, params: { invoiceNo: invoice.invoiceNo } }">Edit Invoice</router-link>
                    
                <button class="btn-danger btn-sm text-xs" title="Delete" @click.prevent="CancelLPO(invoice.invoiceNo)">
                  <i class="fa fa-trash"></i></button>
                  <!-- <confirm-delete
                    :Invoice="invoice.invoiceNo" 
         :showModal="confirmcancel"
          @closeModal="confirmcancel=!confirmcancel, fetchUnpostedInvoices"></confirm-delete> -->
                  
              </td>
                </tr>
            </tbody>
        </table>
        <ConfirmCancelInvoice
         :invoiceNo="currentinvoiceNo" 
         :showModal="confirmcancel"
          @closeModal="fetchUnpostedInvoices">
          </ConfirmCancelInvoice>
    </div>
</template>
